import React from 'react';
import { connect } from 'react-redux';
// Thumbnail imports
import ThumbnailItem from './item';
// Game(kit) imports
import gameKit from '../../../../../GameKit';
import { GuidePublishState } from '../../../../shared';

// Popup imports
class ThumbnailPicker extends React.Component {
    onThumbnailSelect = (uuid) => {
        gameKit.updateSelectedScreenshot(uuid);
    }

    getThumbnailItems = () => {
        const { game } = this.props;
        const { thumbnail } = game;
        const thumbnails = [];
        
        for(let i = 0; i < game.levels.length; ++i) {
            const level = game.levels[i];

            if(level.thumbnail !== undefined) {
                const isCurrent = level.uuid === thumbnail;
                thumbnails.push(
                    <ThumbnailItem
                        key={i}
                        index={i}
                        uuid={level.uuid}
                        thumbnail={level.thumbnail}
                        onSelect={this.onThumbnailSelect}
                        isCurrent={isCurrent}
                    />
                );
            }
        }

        return thumbnails;
    }

    render = () => {
        const { gameGuide, backBtn } = this.props;
        const thumbnails = this.getThumbnailItems();
        const containerClassName = "back-thumbnail-container";

        const error = (
            gameGuide.publishState & GuidePublishState.THUMBNAIL
            ? 'error'
            : ''
        )

        if(thumbnails.length <= 0) {
            return (
                <div className={containerClassName}>
                    {backBtn}
                </div>
            );
        }
        return (
            <div className={containerClassName}>
                <div className={`thumbnail-picker ${error}`}>
                    {thumbnails}
                </div>
                {backBtn}
            </div>
        );
    }
}

ThumbnailPicker.defaultProps = { 
    backBtn: <></>
};

const mapStateToProps = state => ({
    game: state.game,
    gameGuide: state.gameGuide
});

export default connect(
    mapStateToProps
)(ThumbnailPicker);